<template>
    <div
        v-spinner="loading"
        class="app-manage"
    >
        <v-spinner :opacity="0.5">
            加载中...
        </v-spinner>
        <template v-if="!loading">
            <v-page-header
                title="应用管理"
            />
            <div class="app-manage-category">
                <app-category
                    v-for="group of appGroupList"
                    :key="group.group_id"
                    :group="group"
                    @click="handleClick"
                />
                <app-category-staff
                    v-for="group of appStaffList"
                    :key="group.group_id"
                    :group="group"
                    @click="handleClick"
                    @update="fetchAppList"
                />
            </div>
        </template>
        <app-install-panel
            ref="installPanel"
            :from-bind="false"
            :bind-contact="true"
            :business-id="businessId"
            @bindContactChange="onBindContactChange"
        />
        <!-- 选择安装模版 -->
        <select-install-template-panel
            v-if="selectInstallTemplatePanelVisiable"
            :template-list="templateList"
            :show.sync="selectInstallTemplatePanelVisiable"
            @on-install-app="handleSelectApp"
        />
        <OrdinaryRobotActive
            ref="activeRef"
            :robot-id="toActiveRobotId"
            @afterActive="afterActive"
        />
    </div>
</template>

<script>
import cookie from '@/utils/cookie';
import AppInstallPanel from '@/components/app-install-panel';
import { getInstallCallBackByUrlParams } from '@/components/app-install-panel/src/api';
import Gateway from '@/utils/Gateway';
import AppCategory from './components/app-category';
import AppCategoryStaff from './components/app-category-staff';
import SelectInstallTemplatePanel from './components/select-install-template-panel';
import OrdinaryRobotActive from './components/OrdinaryRobotActive.vue';
import { APP_INFO_KEY, APP_ID_KEY, ROBOT_ID_KEY } from '../const';
import { envDomain } from '@/utils/domainConfig';

const SESSION_IS_SSC_KEY = 'qd_robot_is_ssc';
const APP_SETTING_URL = '/mng/account/wework/AppPrivilege';
const ROBOT_SETTING_URL = '/pages/cs/robot.html#/settings';

export default {
    name: 'AppManage',
    components: {
        AppCategory,
        AppInstallPanel,
        SelectInstallTemplatePanel,
        AppCategoryStaff,
        OrdinaryRobotActive,
    },
    data() {
        return {
            appGroupList: [],
            loading: false,
            // templateId: '',
            businessId: '',
            appId: '',
            appname: '',
            isBindContact: false,
            templateList: [],
            selectInstallTemplatePanelVisiable: false,
            isLoaded: false,
            appStaffList: [],
            // 将要激活的普通机器人 id
            toActiveRobotId: '',
            // 将要激活的普通机器人应用是否安装
            isCurrentRobotInstalled: false,
        };
    },
    created() {
        this.fetchAppList();
    },
    methods: {
        handleSelectApp(app) {
            this.showInstallPanel(app);
        },
        fetchAppList() {
            this.loading = true;
            this.appGroupList = [];
            this.appStaffList = [];
            Gateway.get('/v1/wework/staff/staffAppList')
                .then((res) => {
                    this.loading = false;
                    // if (res.code === 0) {
                    // this.templateId = res.data.register_template;
                    // this.appGroupList = res.staff_app_group;
                    this.showInstallResultByParams();
                    this.getBindContactStatus();
                    res.staff_app_group.forEach((item) => {
                        if (item.group_id === 1) {
                            this.appGroupList.push(item);
                        } else {
                            this.appStaffList.push(item);
                        }
                    });
                    // } else {
                    //     this.$message.error(res.message || '网路错误');
                    // }
                })
                .catch((err) => {
                    this.loading = false;
                    throw err;
                });
        },
        // 大模型机器人固定跳转地址
        jump(app, isStaff, jumpTo) {
            const { chat_gpt_type: robotFlag, robot_id: robotId, jump_url: jumpUrl } = app;
            // 存储当前 app 的信息,供其他页面使用
            const appInfo = JSON.stringify({
                icon: app.avatar,
                name: app.app_name,
                id: app.app_id,
                token: app.token,
                robotId: app.robot_id,
                agentId: app.agent_id,
                corpId: app.corp_id,
            });
            // APP_INFO_KEY: staff_service_app_info
            localStorage.setItem(APP_INFO_KEY, appInfo);

            // 存储 appid 到 cookie，供后端使用 APP_ID_KEY: staff_service_app_id
            cookie.set(APP_ID_KEY, app.app_id, { domain: '.qidian.qq.com', path: '/' });
            // 存储 robot id 到 cookie，供后端使用渲染页面的时候用
            // ROBOT_ID_KEY: ROBOT_ID_KEY
            cookie.set('zhiku_robot_id', app.robot_id, { domain: window.location.hostname, path: '/' });
            cookie.set(ROBOT_ID_KEY, app.robot_id, { domain: window.location.hostname, path: '/zhiku' });
            // 机器人 id 写入 mp、mng 子站，会使用机器人 id 去调用 filterMenu 接口获取菜单
            cookie.set(ROBOT_ID_KEY, app.robot_id, { domain: window.location.hostname, path: '/mp' });
            cookie.set(ROBOT_ID_KEY, app.robot_id, { domain: window.location.hostname, path: '/mng' });
            // 专家工作台和员工应用都要写 ssc 标志
            sessionStorage.setItem(SESSION_IS_SSC_KEY, 1);
            cookie.set(SESSION_IS_SSC_KEY, 1, { domain: window.location.hostname, path: '/zhiku' });
            cookie.set(SESSION_IS_SSC_KEY, 1, { domain: window.location.hostname, path: '/mp' });
            cookie.set(SESSION_IS_SSC_KEY, 1, { domain: window.location.hostname, path: '/mng' });
            /**
             * 大模型机器人跳转
             * chat_gpt_type：1 大模型机器人
             * jump_url：跳转链接
             */
            if (+robotFlag === 1) {
                // pages新路径添加cookie
                cookie.set(ROBOT_ID_KEY, robotId, { domain: window.location.hostname, path: '/pages' });
                cookie.set(SESSION_IS_SSC_KEY, 1, { domain: window.location.hostname, path: '/pages' });
                if (jumpTo) {
                    const jumpToAppSetting = jumpTo === 'appSetting';
                    const url = jumpToAppSetting ? APP_SETTING_URL : ROBOT_SETTING_URL;
                    window.open(url, '_blank');
                }
                return;
            }
            if (app.robot_ver_flag && isStaff) {
                window.location.href = jumpUrl || `${envDomain.gateway}/v1/menu/SSCNewRobotRedirect`;
            } else { // 老机器人、专家工作台
                let jumpAddress =  `${envDomain.gateway}/v1/menu/SSCNewRobotRedirect`;
                if (!isStaff) {
                    jumpAddress += '?source=expert';
                }
                window.location.href = jumpAddress;
            }
        },
        handleClick(app, isStaff, jumpTo) {
            /**
             * ssc 普通机器人之前是手动激活的，自接入大模型开始要加入客户可激活机器人逻辑
             * 只有普通机器人有激活一说，大模型机器人开通后就可直接使用
             * 点击后需要添加以下前置逻辑：
             * 1，是员工应用 2，是普通机器人 3，机器人未激活
             * 满足以上 3 个条件弹出普通机器人激活弹窗，激活成功后跳转应用安装页面
             */
            const {
                chat_gpt_type: gptFlag,
                robot_active_flag: isActive,
                robot_id: robotId,
                status,
            } = app;
            if (isStaff && +gptFlag !== 1 && +isActive !== 1) {
                this.toActiveRobotId = robotId;
                this.isCurrentRobotInstalled = 1 === status;
                this.$refs.activeRef.open();
                return;
            }
            // 已安装
            if (app.status === 1) {
                this.jump(app, isStaff, jumpTo);
            } else {
                if (+gptFlag !== 1) window.location.href = '/mng/weworkAccount/index/app';
            }
        },

        install(app) {
            if (app.is_multi_tmpl) {
                this.selectInstallTemplatePanelVisiable = true;
                this.templateList = app.app_templates || [];
            } else {
                this.showInstallPanel(app);
            }
        },

        showInstallPanel(app, isCallBack) {
            this.businessId = app.tmpl_business;
            const transAppInfo = {
                suite_id: app.app_id,
                name: app.app_name,
                ...app,
            };

            this.$refs.installPanel.showByStatus(transAppInfo, isCallBack);
        },

        showInstallResultByParams() {
            const { suiteId, isInstallCallBack } = getInstallCallBackByUrlParams() || {};

            if (isInstallCallBack && suiteId) {
                let appInfo = null;

                this.appGroupList.some((gItem) => {
                    if (gItem.app_infos && gItem.app_infos.length) {
                        return gItem.app_infos.some((aItem) => {
                            if (aItem.app_id === suiteId) {
                                appInfo = aItem;
                                return true;
                            }

                            return false;
                        });
                    }
                    return false;
                });

                if (appInfo) {
                    this.showInstallPanel(appInfo, true);
                }
            }
        },

        getBindContactStatus() {
            this.$nextTick(() => {
                const hasInstallApp = this.appGroupList.some((gItem) => {
                    if (gItem.app_infos && gItem.app_infos.length) {
                        return gItem.app_infos.some((aItem) => {
                            if (aItem.status === 1) {
                                return true;
                            }

                            return false;
                        });
                    }
                    return false;
                });

                if (hasInstallApp) {
                    this.$refs.installPanel.getBindContact();
                }
            });
        },

        onBindContactChange(val) {
            console.log('onBindContactChange', val);
            this.isBindContact = val;
            this.isLoaded = true;
        },
        afterActive() {
            // 普通机器人激活后如果应用未安装，跳安装界面
            if (!this.isCurrentRobotInstalled) window.location.href = '/mng/weworkAccount/index/app';
        },
    },
};
</script>

<style lang="less">
@import './styles/app.less';
</style>
